import { EVENT_FIELDS } from "../../constants/analytics.es.js";
import { p as pickFields } from "../../../pickFields-27454ddf.js";
const extractUserConsent = (payload) => {
  if (!payload.properties.user_consent) {
    return void 0;
  }
  return pickFields(
    [
      EVENT_FIELDS.CONSENT_ID,
      EVENT_FIELDS.CONSENT_ID_SOURCE,
      EVENT_FIELDS.CONSENT_MEDIA,
      EVENT_FIELDS.CONSENT_SCOPE,
      EVENT_FIELDS.CONSENT_TEXT
    ],
    payload.properties.user_consent
  );
};
export {
  extractUserConsent
};
